import React, { useState, useCallback, useRef, useEffect } from 'react';
import { useDrag } from 'react-dnd';
import { Mixpanel } from 'helpers/Mixpanel';
import '../Cell/Cell.scss';
import presenter from 'pages/ScheduleCalendar/duck/presenter';
import styled from '../Cell/styled';
import draftLogic from 'pages/ScheduleCalendar/duck/draftLogic';
import { isValidObject } from 'helpers/validation';
import { getShiftDetails } from '../shared/cellUtils';
import { getRoleTagColor, findFirstRoleTag} from 'pages/ScheduleCalendar/duck/tagUtil';
import constants from 'pages/ScheduleCalendar/constants';
import text from 'strings/text';

export function VTODraggableCell ({user,
    shifts,
    selectedDateToAddShift,
    date,
    handleVTODetail,
    copyVTOToDateDispatch,
    shiftToCopy,
    isCopyingShift,
    roles,
    }) {

  const ref = useRef(null);

  const canDragVTO = useCallback(() => {
    if( shifts != null ){
      const shiftToDrag = shifts[0];
      if( shiftToDrag != null){
        if ( shiftToDrag.trade_status === 'unpublished_posted') { 
          return true;
        }else{
          return false;
        }
      }
    }
    return false;
  }, [shifts]);

  const [{isDragging, canDrag}, drag] = useDrag(() => ({
    type: 'VTOCell',
    item: () => (shifts?.length ? shifts[0] : { id: 0 }),
    collect: monitor => ({
      isDragging: monitor.isDragging(),
    }),
    canDrag:  canDragVTO(),
  }), [canDragVTO, shifts])

  drag(ref);

  const [isMouseOverCell, setIsMouseOverCell] = useState(false);

  const onCellClick = useCallback(() => {
    if (shifts && shifts.length > 0) {
      Mixpanel.track('View VTO detail', { 'date': date.format('YYYY-MM-DD') });
      handleVTODetail(shifts[0], date);
    } else {
      setIsMouseOverCell(false);
      selectedDateToAddShift(user, date, constants.ShiftCreationType.VTO);

      Mixpanel.track('Add VTO', { 'date': date.format('YYYY-MM-DD') });
    }
  }, [shifts, user, date, handleVTODetail, selectedDateToAddShift]);

  const onPasteClick = useCallback(() => {
    setIsMouseOverCell(false);
    copyVTOToDateDispatch(shiftToCopy, date, shiftToCopy.location_id);
    Mixpanel.track('Paste VTO');
  }, [copyVTOToDateDispatch, shiftToCopy, user, date]);

  const onEmptyCellMouseEnter = () => { setIsMouseOverCell(true); };
  const onEmptyCellMouseLeave = useCallback(() => { setIsMouseOverCell(false); }, []);
 
  if ( isValidObject(shifts) == false || shifts.length === 0) {
    if (isCopyingShift && shiftToCopy !== null) {
      if( draftLogic.isDraftVTO(shiftToCopy) == true || draftLogic.isVTO(shiftToCopy) == true ){
        return presenter.pasteShiftCell(onPasteClick, onEmptyCellMouseEnter, onEmptyCellMouseLeave, isMouseOverCell, true);
      }else{
        return (<br/>);
      }
    } else {
      return presenter.addNewShiftCell(onCellClick, onEmptyCellMouseEnter, onEmptyCellMouseLeave, isMouseOverCell);
    }
  }

  const shiftObject = shifts[0];
  const { position, hours, timeRange } = getShiftDetails(shiftObject);
  const tagText = presenter.statusTagForVTOCard(shiftObject)
  const isDraftShift = draftLogic.isDraftVTO(shiftObject);
  const roleTagColor = getRoleTagColor(roles, shiftObject);
  const roleTag = findFirstRoleTag(roles, shiftObject);
  const positionOrRoleName = presenter.getRoleNameOrJobTitle([roleTag], position);
  const cardName = presenter.cardClassNameForVTO(shiftObject);

  const bottomLine = (
    <styled.DayCellBottomLineWrap>
      <styled.DayCellTextVTO>{text.VTO()}</styled.DayCellTextVTO> <styled.Dot />
      <styled.DayCellTextPosition>{positionOrRoleName}</styled.DayCellTextPosition>
      {typeof positionOrRoleName === 'string' && positionOrRoleName.length > 0 && <styled.Dot />}
      <styled.BottomLineText>{presenter.textHours(hours)}</styled.BottomLineText>
    </styled.DayCellBottomLineWrap>
  );

  return (
    <div className= {"day-cell-top-wrap " + cardName } ref={ref} onMouseUpCapture={onCellClick} key= {shifts[0].id}>
        {tagText !== '' && <span className='status-tag'> {tagText} </span>}

        <div className= {(isDraftShift) ? 'day-cell dotted-border': 'day-cell solid-border'} style={{backgroundColor: '#ffffff', borderColor: presenter.borderColorFromRoleTagColor(roleTagColor)}}>
          <div className='top-row'> <label className='vto-bubble'> {shiftObject.total_shifts_available} </label> <label className='time-label'> {timeRange} </label> </div>
          {bottomLine}
        </div>

    </div>
  );

};

export default VTODraggableCell; 